export default __webpack_public_path__ + "static/media/Logo_Personal_Body_Plan.b3089be9.svg";